import { Link } from 'react-router-dom';

import { Button } from 'components/ui/button';

import MainAppBar from 'components/MainAppBar';
import EventPageSkeleton from 'components/EventPageSkeleton';
import Storefront from 'components/Storefront';

import { Trans } from '@lingui/macro';
import { EventProvider, useEventContext } from 'context/EventContext';
import { StorefrontProvider } from 'context/StorefrontContext';

function Page() {
    const { status, storefrontKey } = useEventContext();

    switch (status) {
        case 'Success':
            return <Storefront key={storefrontKey} />;

        case 'Loading':
            return (
                <div className="min-h-full bg-background text-foreground">
                    <MainAppBar />
                    <EventPageSkeleton />
                </div>
            );

        case 'Error':
            return (
                <div className="min-h-full bg-background text-foreground">
                    <MainAppBar />
                    <ErrorScreen />
                </div>
            );

        default:
            return (
                <div className="min-h-full bg-background text-foreground">
                    <MainAppBar />
                    <ErrorScreen />
                </div>
            );
    }
}

function ErrorScreen() {
    return (
        <div className="flex min-h-[calc(100vh-160px)] w-full flex-col items-center justify-center px-4">
            <h1 className="mb-6 text-center text-xl font-semibold text-foreground sm:text-2xl">
                <Trans>Sorry we couldn't find that event</Trans>
            </h1>
            <Button variant="outline" asChild>
                <Link to="/">
                    <Trans>View all events</Trans>
                </Link>
            </Button>
        </div>
    );
}

export default function EventPage() {
    return (
        <EventProvider>
            <StorefrontProvider>
                <Page />
            </StorefrontProvider>
        </EventProvider>
    );
}
